import { render } from "./GridDialogList.vue?vue&type=template&id=66344a64&scoped=true"
import script from "./GridDialogList.vue?vue&type=script&lang=js"
export * from "./GridDialogList.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./GridDialogList.vue?vue&type=style&index=1&id=66344a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66344a64"]])

export default __exports__